import Sidebar from 'sidebar-v2/js/leaflet-sidebar.js'

import 'sidebar-v2/css/leaflet-sidebar.css'

export default Sidebar
